import { Award } from 'lucide-react';

const awards = [
  {
    logo: `${__BASE_PATH__}assets/recognition/premio-reclame-aqui-2025.png`,
    logoClass: 'max-h-20 max-w-20',
    title: 'Prêmio RA 2025',
    description: 'Empresa indicada',
  },
  {
    logo: `${__BASE_PATH__}assets/recognition/ra1000.png`,
    logoClass: 'max-h-14 max-w-24',
    title: 'Selo RA1000',
    description: 'Excelência no atendimento',
  },
  {
    logo: `${__BASE_PATH__}assets/recognition/gptw.png`,
    logoClass: 'max-h-20 max-w-16',
    title: 'GPTW',
    description: 'Excelente lugar para trabalhar',
  },
  {
    logo: `${__BASE_PATH__}assets/recognition/abgd.png`,
    logoClass: 'max-h-14 max-w-24',
    title: 'ABGD',
    description: 'Associada à geração distribuída',
  },
  {
    logo: `${__BASE_PATH__}assets/recognition/total-quality-2026.png`,
    logoClass: 'max-h-20 max-w-20',
    title: 'Total Quality 2026',
    description: 'Latin American Quality Institute',
  },
];

export default function AwardsSection() {
  return (
    <section
      id="reconhecimento"
      className="relative z-20 w-full"
      aria-labelledby="reconhecimento-title"
    >
      <div className="container-wide pb-6 md:pb-8">
        <div className="overflow-hidden rounded-2xl border border-background-800/50 bg-background-950/75 px-4 py-5 shadow-[0_20px_60px_-40px_rgba(0,220,90,0.55)] backdrop-blur-md md:px-6">
          <div className="mb-4 flex flex-col items-center justify-between gap-4 border-b border-background-800/50 pb-4 text-center md:flex-row md:text-left">
            <div className="flex flex-col items-center gap-3 md:flex-row">
              <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-xl bg-primary-500/15 text-primary-400 ring-1 ring-primary-500/25">
                <Award className="h-5 w-5" />
              </span>
              <div>
                <span className="text-xs font-semibold uppercase tracking-[0.16em] text-primary-400">
                  Reconhecimento
                </span>
                <h2 id="reconhecimento-title" className="font-heading text-base font-bold text-white md:text-lg">
                  Prêmios e certificações
                </h2>
              </div>
            </div>
            <p className="hidden text-xs text-foreground-500 lg:block">
              Qualidade, credibilidade e excelência reconhecidas.
            </p>
          </div>

          <div className="recognition-scroll overflow-x-visible md:overflow-x-auto">
            <div className="grid grid-cols-1 divide-y divide-background-800/60 md:min-w-[65rem] md:grid-cols-5 md:divide-x md:divide-y-0 lg:min-w-0">
              {awards.map((award) => (
                <article
                  key={award.title}
                  className="flex min-w-0 flex-col items-center gap-2 px-2 py-5 text-center md:flex-row md:gap-3 md:px-4 md:py-0 md:text-left md:first:pl-1 md:last:pr-1"
                >
                  <div className="flex h-20 w-24 shrink-0 items-center justify-center">
                    <img
                      src={award.logo}
                      alt={`Logotipo ${award.title}`}
                      className={`h-auto w-auto object-contain ${award.logoClass}`}
                      loading="lazy"
                    />
                  </div>
                  <div className="min-w-0">
                    <h3 className="text-sm font-bold leading-snug text-white">
                      {award.title}
                    </h3>
                    <p className="mt-1 text-xs leading-relaxed text-foreground-500">
                      {award.description}
                    </p>
                  </div>
                </article>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
